
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import KaraokeHero from '../tokyo-karaoke-night/components/KaraokeHero';
import KaraokeConcept from '../tokyo-karaoke-night/components/KaraokeConcept';
import KaraokeServices from '../tokyo-karaoke-night/components/KaraokeServices';
import KaraokePricing from '../tokyo-karaoke-night/components/KaraokePricing';
import KaraokeNotice from '../tokyo-karaoke-night/components/KaraokeNotice';
import KaraokeFaq from '../tokyo-karaoke-night/components/KaraokeFaq';
import KaraokeFinalCta from '../tokyo-karaoke-night/components/KaraokeFinalCta';
import KaraokeWhatsAppButton from '../tokyo-karaoke-night/components/KaraokeWhatsAppButton';

export default function TokyoKaraokeNightEnPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Tokyo Karaoke Night - Experience Japanese Karaoke | Tokyo Local Concierge';
    document.documentElement.lang = 'en';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'No stress. Just fun. Experience Japanese karaoke like a local friend. Pre-booking, machine support, popular song recommendations. From ¥18,000 for 3 hours. Easy WhatsApp booking.');
    setMeta('keywords', 'Tokyo karaoke,karaoke experience,Airbnb guests,karaoke box,J-Pop,anime songs,Tokyo nightlife,Tokyo tourism,karaoke booking');
    setMeta('og:title', 'Tokyo Karaoke Night - Experience Japanese Karaoke | Tokyo Local Concierge', true);
    setMeta('og:description', 'No stress. Just fun. Experience Japanese karaoke like a local friend. Pre-booking, machine support, popular song recommendations.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyolocalconcierge.com/tokyo-karaoke-night-en', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Karaoke Night - Experience Japanese Karaoke');
    setMeta('twitter:description', 'No stress. Just fun. Experience Japanese karaoke like a local friend.');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setMeta('geo.position', '35.6762;139.6503');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <KaraokeHero lang="en" />
        <KaraokeConcept lang="en" />
        <KaraokeServices lang="en" />
        <KaraokePricing lang="en" />
        <KaraokeNotice lang="en" />
        <KaraokeFaq lang="en" />
        <KaraokeFinalCta lang="en" />
      </main>
      <Footer />
      <KaraokeWhatsAppButton lang="en" />
    </div>
  );
}
